// AUTO-GENERATED by build.mjs — do not edit by hand.
// Static Stimulus registrations for the esbuild bundle (mirrors the
// importmap eagerLoadControllersFrom behavior).
import { application } from "controllers/application"

import AddressAutocompleteController from "controllers/address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)
import AiProofreadController from "controllers/ai_proofread_controller"
application.register("ai-proofread", AiProofreadController)
import BetaDisclaimerController from "controllers/beta_disclaimer_controller"
application.register("beta-disclaimer", BetaDisclaimerController)
import ClientCityController from "controllers/client_city_controller"
application.register("client-city", ClientCityController)
import ClientSectionController from "controllers/client_section_controller"
application.register("client-section", ClientSectionController)
import CommChartController from "controllers/comm_chart_controller"
application.register("comm-chart", CommChartController)
import CookieConsentController from "controllers/cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)
import CosRelationshipController from "controllers/cos_relationship_controller"
application.register("cos-relationship", CosRelationshipController)
import CsSuggestionsController from "controllers/cs_suggestions_controller"
application.register("cs-suggestions", CsSuggestionsController)
import CsToolbarController from "controllers/cs_toolbar_controller"
application.register("cs-toolbar", CsToolbarController)
import CurrentServicesListController from "controllers/current_services_list_controller"
application.register("current-services-list", CurrentServicesListController)
import DeleteAccountController from "controllers/delete_account_controller"
application.register("delete-account", DeleteAccountController)
import DilTogglesController from "controllers/dil_toggles_controller"
application.register("dil-toggles", DilTogglesController)
import DynamicListController from "controllers/dynamic_list_controller"
application.register("dynamic-list", DynamicListController)
import EditorNativeController from "controllers/editor_native_controller"
application.register("editor-native", EditorNativeController)
import EditorToolbarController from "controllers/editor_toolbar_controller"
application.register("editor-toolbar", EditorToolbarController)
import FeatureUsageController from "controllers/feature_usage_controller"
application.register("feature-usage", FeatureUsageController)
import GoalReferencesController from "controllers/goal_references_controller"
application.register("goal-references", GoalReferencesController)
import GoalReorderController from "controllers/goal_reorder_controller"
application.register("goal-reorder", GoalReorderController)
import GoalResourcesController from "controllers/goal_resources_controller"
application.register("goal-resources", GoalResourcesController)
import GoalWalkthroughController from "controllers/goal_walkthrough_controller"
application.register("goal-walkthrough", GoalWalkthroughController)
import HeartbeatController from "controllers/heartbeat_controller"
application.register("heartbeat", HeartbeatController)
import HelloController from "controllers/hello_controller"
application.register("hello", HelloController)
import HelpGuideController from "controllers/help_guide_controller"
application.register("help-guide", HelpGuideController)
import IppMeetingController from "controllers/ipp_meeting_controller"
application.register("ipp-meeting", IppMeetingController)
import IssueLogController from "controllers/issue_log_controller"
application.register("issue-log", IssueLogController)
import IssueTableController from "controllers/issue_table_controller"
application.register("issue-table", IssueTableController)
import LanguagePickerController from "controllers/language_picker_controller"
application.register("language-picker", LanguagePickerController)
import NameTokenController from "controllers/name_token_controller"
application.register("name-token", NameTokenController)
import OnboardingTourController from "controllers/onboarding_tour_controller"
application.register("onboarding-tour", OnboardingTourController)
import OpenQuestionsController from "controllers/open_questions_controller"
application.register("open-questions", OpenQuestionsController)
import ParamTagToolbarController from "controllers/param_tag_toolbar_controller"
application.register("param-tag-toolbar", ParamTagToolbarController)
import PlanHistoryController from "controllers/plan_history_controller"
application.register("plan-history", PlanHistoryController)
import PlanI18nController from "controllers/plan_i18n_controller"
application.register("plan-i18n", PlanI18nController)
import PlanModesController from "controllers/plan_modes_controller"
application.register("plan-modes", PlanModesController)
import PlanStoreController from "controllers/plan_store_controller"
application.register("plan-store", PlanStoreController)
import PrintPreviewController from "controllers/print_preview_controller"
application.register("print-preview", PrintPreviewController)
import ProofreadBucketController from "controllers/proofread_bucket_controller"
application.register("proofread-bucket", ProofreadBucketController)
import ReferencePanelController from "controllers/reference_panel_controller"
application.register("reference-panel", ReferencePanelController)
import ResourceCalendarController from "controllers/resource_calendar_controller"
application.register("resource-calendar", ResourceCalendarController)
import RevisionHistoryController from "controllers/revision_history_controller"
application.register("revision-history", RevisionHistoryController)
import SaveStatusController from "controllers/save_status_controller"
application.register("save-status", SaveStatusController)
import SdpController from "controllers/sdp_controller"
application.register("sdp", SdpController)
import SectionToolbarController from "controllers/section_toolbar_controller"
application.register("section-toolbar", SectionToolbarController)
import SettingsGoalsController from "controllers/settings_goals_controller"
application.register("settings-goals", SettingsGoalsController)
import SettingsSectionsController from "controllers/settings_sections_controller"
application.register("settings-sections", SettingsSectionsController)
import SettingsServicesController from "controllers/settings_services_controller"
application.register("settings-services", SettingsServicesController)
import SettingsVendorsController from "controllers/settings_vendors_controller"
application.register("settings-vendors", SettingsVendorsController)
import SidebarReorderController from "controllers/sidebar_reorder_controller"
application.register("sidebar-reorder", SidebarReorderController)
import TabLockController from "controllers/tab_lock_controller"
application.register("tab-lock", TabLockController)
import ThemePickerController from "controllers/theme_picker_controller"
application.register("theme-picker", ThemePickerController)
import ThemeToggleController from "controllers/theme_toggle_controller"
application.register("theme-toggle", ThemeToggleController)
import ToolbarOverflowController from "controllers/toolbar_overflow_controller"
application.register("toolbar-overflow", ToolbarOverflowController)
import UnmetNeedsListController from "controllers/unmet_needs_list_controller"
application.register("unmet-needs-list", UnmetNeedsListController)
import VendorBrochureController from "controllers/vendor_brochure_controller"
application.register("vendor-brochure", VendorBrochureController)
import VendorIntakeController from "controllers/vendor_intake_controller"
application.register("vendor-intake", VendorIntakeController)
import VendorPickerController from "controllers/vendor_picker_controller"
application.register("vendor-picker", VendorPickerController)
import WizardController from "controllers/wizard_controller"
application.register("wizard", WizardController)
